var moment = require('js/lib/moment');

module.exports = function() {

  return function(date, format) {
    if (! date) return null;
    return moment(date).format(format);
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/moment.js
 ** module id = 165
 ** module chunks = 1
 **/